export function stripNotNumeric(value: string) {
  return value.replace(/\D/g, "");
}
